import React, { Component } from 'react'
import Button from 'components/button/button'
import * as actions from 'state/actions'
import { } from 'state/actions'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import ProfilePicture from 'components/profile/profile-picture'

import { deletePendingInvitation, acceptInvitation } from 'state/actions'
import { getCurrentUser } from 'state/selectors/userSelectors'

class ModalPendingInvitation extends Component {
	constructor(props){
		super(props);

		this.state = {
			step: 0
		}

		this.validationError = false;
	}

	changeStep = step => {
		this.setState({
			step: step
		})
	}

	accept = _ => {
		const {
			data,
			acceptInvitation,
			history
		} = this.props

		if(!this.validationError){
			const newAccountSlug = data.invitation.account.slug

			acceptInvitation(data.invitation, _ => {
				history.push('/'+newAccountSlug)
			})
		}

		this.removeAndClose()
	}

	removeAndClose = _ => {
		const {
			deletePendingInvitation,
			data,
			closeCallback
		} = this.props

		deletePendingInvitation(data.invitation.id)
		closeCallback()
	}

	componentWillMount = _ => {
		const {
			data,
			userData
		} = this.props

		this.validationError = this.hasValidationError(data.invitation, userData)
	}

	componentWillUnmount(){
		this.removeAndClose()
	}

	hasValidationError = invitation => {
		if(invitation == 'TAKEN'){
			return 'This invitation has already been accepted';
		}

		if(!invitation.id){
			return 'An unknown error occurred.';
		}

		if(this.props.userData && invitation.recipient_email.toLowerCase() !== this.props.userData.email.toLowerCase()){
			return 'This invitation is for a different user.';
		}
	}

	render() {
		const {
			data
		} = this.props

		if(data.invitation){
			let className = "modal-task borders"
			let objectName = 'null'

			const { 
				invitation 
			} = data

			let subtitle = 'null'
			let step

			let buttonLabels = []

			if(!this.validationError){
				step = this.state.step

				objectName = invitation.account.name;
				subtitle = `invited by ${invitation.inviter.first_name} ${invitation.inviter.last_name}`;

				if(invitation.account.image_url){
					className += ' with-image';
				}

				buttonLabels = [
					{
						high: 'Yep',
						low: 'No thanks'
					},
					{
						high: 'Okay',
						low: 'Go back'
					}
				]
			}else{
				step = 1;

				buttonLabels = [
					{

					},
					{
						high: 'Okay',
					}
				]
			}

			return(
				<div>
					<div className={className}>
						<div className={step == 1 ? "response-cover visible" : "response-cover"}>
							{
								this.validationError ?
								<p>
									{ this.validationError }
								</p>
								:
								<p>
									We're heading over to <strong>{ objectName }</strong> now. <br />
									You can swap organizations at any time under 'My organizations'!
								</p>
							}
						</div>
						<div className={step == 1 ? 'hidden pre-response' : 'pre-response' }>
							{
								!this.validationError && invitation.account && invitation.account.image_url ?
								<ProfilePicture account={true} handleImageChange={null} editable={false} url={invitation.account.image_url} />
								: null
							}
							<h3>
								{ objectName }
							</h3>
							<span>
								{ subtitle }
							</span>
						</div>
					</div>
					<Button 
						size={'big'} 
						level={'high'} 
						callback={_ => {step == 0 ? this.changeStep(1) : this.accept()}} 
						label={buttonLabels[step].high} 
						icon={'check'} 
					/>
					{
						buttonLabels[step].low ?
						<Button 
							size={'big'} 
							level={'low'} 
							callback={_ => {step == 0 ? this.removeAndClose() : this.changeStep(0) }} 
							label={buttonLabels[step].low} 
						/>
						: null
					}
				</div>
			);
		}else{
			return null;
		}
	}
}

const mapStateToProps = state => {
  return {
  	userData: getCurrentUser(state),
  };
}

export default withRouter(connect(mapStateToProps, { deletePendingInvitation, acceptInvitation })(ModalPendingInvitation));



// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-pending-invitation.jsx